import { ReactNode } from 'react';
import { Paper, PaperProps, Stack, Typography } from '@mui/material';

type InfoCardProps = {
  icon: ReactNode;
  title: string;
  subtitle: string;
  action?: ReactNode;
} & PaperProps;
export const InfoCard = ({ icon, sx, title, subtitle, action, ...rest }: InfoCardProps) => {
  return (
    <Paper sx={{ px: 4, py: 2, ...sx }} {...rest}>
      <Stack direction={'row'} alignItems={'center'} gap={4}>
        {icon}
        <Stack gap={0.5}>
          <Typography variant={'h6'}>{title}</Typography>
          <Typography color={'textSecondary'} variant={'subtitle1'}>
            {subtitle}
          </Typography>
        </Stack>
        {action}
      </Stack>
    </Paper>
  );
};
